import React from 'react';
import {motion} from 'framer-motion'
import { fadeIn } from '../../constants/variants';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <motion.div
      variants={fadeIn('right')}
      initial='hidden'
      whileInView={'show'}
      viewport={{ once: false, amount: 0.6 }} 
      className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </motion.div>
    <motion.div
      variants={fadeIn('left')}
      initial='hidden'
      whileInView={'show'}
      viewport={{ once: false, amount: 0.6 }} 
      className="app__wrapper_info">
      <SubHeading title="Chef's word" />
      <h1 className="headtext__cormorant">What we believe in</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">Implementing inventory / stock control software provides restaurant owners and managers with the tools they need to determine where waste occurs and to monitor inventory. Becoming pro-active with easy to use software can help you quickly determine when losses occur and why. </p>
        <p className="p__opensans"> </p>
        </div>
      </div>

      <div className="app__chef-sign">
        <p>Kevin Luo</p>
        <p className="p__opensans">Chef & Founder</p>
        <img src={images.sign} alt="sign_image" />
      </div>
    </motion.div>
  </div>
);

export default Chef;
